import React from 'react';
import { Switch } from 'antd';
import { ComparisonDrawerTitleContainer } from './styles';

const REPORT_TITLE = 'KPI Report';

const ComparisonDrawerTitle = ({
  Actions,
  titleText,
  showKpiReport,
  setShowKpiReport,
  fromDate,
  toDate,
}) => (
    <>
      <ComparisonDrawerTitleContainer>
        <div>
          <b>{titleText}</b>
          <small>
            {`(${fromDate} to ${toDate})`}
          </small>
          <Switch
            checked={showKpiReport}
            onClick={setShowKpiReport}
            checkedChildren={REPORT_TITLE}
            unCheckedChildren={REPORT_TITLE}
          />
        </div>
        {Actions && Actions}
      </ComparisonDrawerTitleContainer>
    </>
);

export default ComparisonDrawerTitle;
